const emptyAccessPointExternal = () => ({
    instructions: '',
    contactInfo: '',
    url: ''
});
const makeAccessPoint = (overrides = {}) => ({
    id: '',
    name: '',
    description: '',
    type: 'velpr',
    external: emptyAccessPointExternal(),
    ...overrides
});
const toAccessPoint = (data) => {
    const type = data?.type === 'external' ? 'external' : 'velpr';
    return {
        id: data?.id ?? '',
        name: data?.name ?? '',
        description: data?.description ?? '',
        type,
        external: {
            instructions: data?.external?.instructions ?? '',
            contactInfo: data?.external?.contactInfo ?? '',
            url: data?.external?.url ?? ''
        }
    };
};
const toAccessPoints = (data) => {
    if (!Array.isArray(data))
        return [];
    return data.map(toAccessPoint).filter((ap) => ap.id !== '');
};
const accessPointById = (siteData, accessPointId) => {
    if (!accessPointId)
        return undefined;
    return siteData.accessPoints.find((ap) => ap.id === accessPointId);
};
const spacesForAccessPoint = (siteData, accessPointId) => {
    return siteData.siteItems.filter((s) => s.accessPointId === accessPointId);
};
/**
 * Instruksjoner (eksternt) for an access point: from the admin-only codes
 * document, falling back to the legacy copy on the world-readable site
 * document for access points not yet saved since D69. Server code and the
 * access-info endpoint use this; the browser never reads the codes document
 * as a customer.
 */
const externalInstructions = (ap, codesDoc) => codesDoc?.accessPointInstructions?.[ap.id] ?? ap.external.instructions;
/**
 * The access points to store on the site document: everything but the
 * instructions, which live in the codes document (D69).
 */
const accessPointsForSiteDoc = (aps) => aps.map((ap) => ({ ...ap, external: { ...ap.external, instructions: '' } }));
/**
 * The instructions map to store in the codes document (D69). Every external
 * access point gets an entry, empty included, so a stale legacy copy on the
 * site document can never win the fallback again.
 */
const instructionsForCodesDoc = (aps) => Object.fromEntries(aps
    .filter((ap) => ap.type === 'external')
    .map((ap) => [ap.id, ap.external.instructions]));
export { accessPointById, accessPointsForSiteDoc, externalInstructions, instructionsForCodesDoc, emptyAccessPointExternal, makeAccessPoint, spacesForAccessPoint, toAccessPoint, toAccessPoints };
//# sourceMappingURL=accessPoint.js.map